<div class="d-flex align-items-center bg-auth" style="height: 100%;min-height:100%;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-xl-8 my-5">

        <div class="text-center">

          <!-- Preheading -->
          <h6 class="text-uppercase text-muted mb-4">
            Questionnaire complété avec succès
          </h6>

          <!-- Heading -->
          <h1 class="display-4 mb-3">
            <i class="fas fa-check text-success"></i> Votre questionnaire a été reçu avec succès
          </h1>


          <!-- Subheading -->
          <div class="mb-4">
            <p>Vous devez maintenant envoyer des documents à votre cabinet comptable. Voici des exemples de documents
              que vous devez
              faire parvenir à votre cabinet comptable:</p>
            <ul class="text-start text-secondary">
              <li>Revenu d’emploi : T4 et Relevé 1</li>
              <li>Revenu de placement : T3, T5, T4A, T5008 ou état des gains/pertes, etc.</li>
              <li>Bourses d’études : T4A</li>
              <li>Retraite publique : Sécurité vieillesse : T4A (OAS) ET RRQ : T4A (P)</li>
              <li>Assurance emploi (chômage) : Relevé T4E</li>
              <li>RQAP Regime Quebecois d’Assurance Parentale : Relevé T4E</li>
              <li>CSST, SAAQ, aide sociale : Relevé 5 ou T5007</li>
              <li>Travailleur autonome : Liste des revenus et depenses</li>
              <li>Revenu locatif : Liste des revenus et depenses</li>
              <li>REER : reçus officiels</li>
              <li>Frais de scolarite : Relevé 8/T2202A</li>
              <li>Intérêts payés sur prêts étudiants : Relevé de la banque ou de la caisse</li>
              <li>Frais medicaux</li>
              <li>Prime d’assurance medicament</li>
              <li>Frais de déménagement</li>
              <li>Dons de charité/ Contributions politiques</li>
              <li>Cotisations syndicales ou professionnelles</li>
              <li>Acomptes provisionnels federal et provincial</li>
              <li>Documents pour le crédit pour maintien à domicile</li>
              <li>Credit de solidarite : Relevé 31 (si locataire)</li>
              <li>Frais de garde d’enfants : RL-24 Non subventionnée</li>
              <li>Credits de garde anticipés : Relevé 19</li>
              <li>Programmes d’activités physiques des enfants et activités artistiques</li>
              <li>Déclaration d'impôts de l'année précédente (nouveaux clients)</li>
              <li>Avis de cotisation fédérale et provinciale de la dernière année déclarée</li>
            </ul>
          </div>

          <div class="alert alert-light">
            Nous travaillons sur une fonctionnalité qui vous permettra bientôt de téléverser vos documents directement
            par notre portail. Entretemps, vous devez envoyer les documents par courriel.
          </div>

          <!-- Button -->
          <a class="btn btn-lg btn-primary" routerLink="/">
            Retourner à l'accueil
          </a>

        </div>

      </div>
    </div> <!-- / .row -->
  </div>
</div>
